// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"53fff10b","946":"9223f1b8"}[chunkId] + ".chunk.js";
};